import './App.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/800.css';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/800.css';
import {Grid} from "@mui/system";
import Pagina from "./Pagina/Pagina";
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {createContext, useEffect} from "react";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";

export const contexApp = createContext()

function App() {
    const {data: testimonios, actualizarDataLocal: actCategorias} = useObtenerDataActualizada({clave: 'testimonios'})

    const valoresProvider = {
        testimonios
    }

    const {Provider} = contexApp;

    useEffect(() => {

        //se verifica si esta o no actualizado
        obtenerFechaAct('testimonios').then((dox) => {
            let w = []
            actCategorias({fecha: dox, wheres: w}).then()
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>

        </Grid>
    );
}

export default App;
